var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import KR from '../lib/KNReiseAPI';
/* const KR = require('imports?_=underscore&$=jquery&CryptoJS=cryptojs!' +
  'string-replace?search=KR\\.&replace=module.exports.&flags=g!' +
  'string-replace?search=CryptoJS\\.&replace=Crypto.&flags=g!' +
  'string-replace?search=_\\.pluck&replace=_.map&flags=g!' +
  'KNReiseAPI');
*/

export var api = new KR.API();
export var sources = [];
export function init(_sources) {
  sources = _sources;
  var KRApiConf = {};
  sources.forEach(function (source) {
    if (source.value.api !== 'avtheme' && source.value.api !== 'avdigitheme' && source.value.api !== 'dimu' && source.categories && source.categories.length) {
      source.value.dataset += ' (dc_subject_text:(' + source.categories.join(') OR dc_subject_text:(') + ')) ';
    }

    if (source.value.api === 'dimu') {
      source.value.uuid = '9b9270a7-c6be-4f55-826a-d0f12253725a';
    }

    if (source.value.api === 'flickr') {
      KRApiConf.flickr = {
        apikey: source.config.apikey
      };
    }
  });
  api = new KR.API(KRApiConf);
}
export function getSource(key) {
  var i = void 0,
      source = void 0; // Check for data index match

  for (i = 0; i < sources.length; ++i) {
    source = sources[i];

    if (source.dataIndex === key) {
      return source;
    }
  } // Backwards compatibility for articles/refs without data source dataIndex


  var keyParts = key.split('/');

  if (keyParts[0] === 'avdigitheme' || keyParts[0] === 'avtheme' || keyParts[0] === 'dimu') {
    // Check for api and uuid match
    for (i = 0; i < sources.length; ++i) {
      source = sources[i];

      if (source.value.api === keyParts[0] && source.value.uuid === keyParts[1]) {
        return source;
      }
    }
  } else {
    // Check for api match
    for (i = 0; i < sources.length; ++i) {
      source = sources[i];

      if (source.value.api === key) {
        return source;
      }
    }
  }
}
export function getActiveSources(activeSources, sources) {
  if (!activeSources || !activeSources.length) {
    return sources.filter(function (s) {
      return s.pressed && s.dataIndex;
    }).map(function (item) {
      return item.dataIndex;
    });
  }

  return activeSources;
}
export function loadArticlesIfNeeded(source, loadState, mapCenter, mapZoom, mapExtent, projCode, filterColumns, pageLimit, loadSource) {
  if (!(loadState && (loadState.isLoaded || loadState.isLoading) && loadState.mapCenter[0] === mapCenter[0] && loadState.mapCenter[1] === mapCenter[1] && loadState.mapZoom === mapZoom && JSON.stringify(loadState.filterColumns) === JSON.stringify(filterColumns))) {
    // Source is not loaded or outdated
    loadSource(getSource(source), mapCenter, mapZoom, mapExtent, projCode, filterColumns, pageLimit);
  }
}
export function getSourceColor(source) {
  var fillColor = source.config.fillColor;

  if (fillColor.indexOf('rgb') === 0 || fillColor.indexOf('#') === 0) {
    return fillColor;
  }

  var colorString = fillColor.split(' ').join(',');
  return 'rgb(' + colorString + ')';
}
export function getFeatureStyle(_ref) {
  var config = _ref.config;
  return _extends({
    fillColor: config.fillColor,
    fillOpacity: config.fillOpacity,
    fontColor: config.fontColor,
    strokeColor: config.borderColor,
    strokeOpacity: config.strokeOpacity,
    strokeWidth: config.strokeWidth,
    pointRadius: config.pointRadius
  }, config.featureStyle);
}
export function getGlobalId(id) {
  var idParts = id.split('_');
  var source = getSource(idParts[0]);

  if (source) {
    switch (source.value.api) {
      case 'avdigitheme':
      case 'avtheme':
      case 'dimu':
        return [source.value.api + '/' + source.value.uuid].concat(idParts.slice(1)).join('_');

      default:
        return [source.value.api].concat(idParts.slice(1)).join('_');
    }
  }

  return id;
}